document.addEventListener('DOMContentLoaded', function(){
    const CLIENTS = [
        { name: "A", lastName: "Schmidt" },
        { name: "B", lastName: "Müller" },
        { name: "C", lastName: "Fischer" },
        { name: "D", lastName: "Weber" },
        { name: "E", lastName: "Schneider" },
        { name: "F", lastName: "Becker" },
        { name: "G", lastName: "Wagner" },
        { name: "H", lastName: "Schulz" },
        { name: "I", lastName: "Hoffmann" },
        { name: "J", lastName: "Schäfer" },
        { name: "K", lastName: "Koch" },
        { name: "L", lastName: "Bauer" },
        { name: "M", lastName: "Richter" },
        { name: "N", lastName: "Klein" },
        { name: "O", lastName: "Wolf" },
        { name: "P", lastName: "Schröder" },
        { name: "Q", lastName: "Neumann" },
        { name: "R", lastName: "Schwarz" },
        { name: "S", lastName: "Zimmermann" },
        { name: "T", lastName: "Braun" },
        { name: "U", lastName: "Krüger" },
        { name: "V", lastName: "Hofmann" },
        { name: "W", lastName: "Hartmann" },
        { name: "X", lastName: "Lange" },
        { name: "Y", lastName: "Schmitt" },
        { name: "Z", lastName: "Werner" },
    ];

    let intervalCustomer;
    const DATA_TIME = 6000;

    const sortArray = (array = []) => {
        return array.sort(() => {
            return Math.random() - 0.5;
        }).splice(0, 5)
    }


    intervalCustomer = setInterval(() => {
        const getActivesCustomer = document.querySelectorAll('.purchase-customer.active');

        getActivesCustomer.forEach(customer => {
            customer.classList.remove('active');
        });

        const cardsProducts = sortArray([...document.querySelectorAll('#product-grid .grid__item')])

        cardsProducts.forEach(product => {
            const getClientRandom = CLIENTS[Math.floor(Math.random() * CLIENTS.length)];
            const wrapperCustomer = product.querySelector('.purchase-customer');
            const customerFirst = wrapperCustomer.querySelector('.customer-first');
            const customerTexts = wrapperCustomer.querySelector('.customer-texts');

            const {name, lastName} = getClientRandom;
            const firstL = getClientRandom.name;

            customerFirst.innerHTML = firstL;
            customerTexts.innerHTML = `Recently bought by ${name}. ${lastName}`;

            wrapperCustomer.classList.add('active');
        })


    }, DATA_TIME);
});